// extracted by mini-css-extract-plugin
export default {"card":"overview-card_card__l7oon"};